<template>
    <v-app id="greenie">
        <!-- Notification -->
        <Snackbar></Snackbar>
        <!-- QR Code Scanner -->
        <QrCodeScanner :dialog.sync="qrCodeScannerDialog"></QrCodeScanner>

        <!-- app bar -->
        <v-app-bar
            v-show="show"
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            color="primary"
            dark
            dense
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer">
                <template>
                    <v-icon>menu</v-icon>
                </template>
            </v-app-bar-nav-icon>
            <v-toolbar-title class="ml-0 pl-4">
                <span link href="/#/">Greenie</span>
            </v-toolbar-title>
            <!-- 
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        icon
                        small
                        fab
                        class="ml-5"
                        @click="qrCodeScannerDialog = !qrCodeScannerDialog"
                        v-on="on"
                    >
                        <v-icon>qr_code_scanner</v-icon>
                    </v-btn>
                </template>
                <span>Scan QR Code</span>
            </v-tooltip> -->

            <v-btn
                icon
                small
                fab
                class="ml-5"
                @click="qrCodeScannerDialog = !qrCodeScannerDialog"
            >
                <v-icon>qr_code_scanner</v-icon>
            </v-btn>

            <v-spacer />

            <v-toolbar-title class="subtitle-2">
                <v-chip class="pa-2 ml-1" label outlined
                    >WEEK {{ today | moment("W") }}</v-chip
                >
            </v-toolbar-title>
            <!-- <v-tooltip bottom v-if="alertsCount.tenantProducts.totalCount > 0">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text @click="goToUnconfiguredProducts">
                        <span>{{ alertsCount.tenantProducts.totalCount }}</span>
                        <v-icon class="error--text ml-1">warning</v-icon>
                    </v-btn>
                </template>
                <span>Unconfigured products</span>
            </v-tooltip>

            <v-tooltip
                bottom
                v-if="alertsCount.tenantSalesOrders.totalCount > 0"
            >
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text @click="goToPendingOrders">
                        <span>{{
                            alertsCount.tenantSalesOrders.totalCount
                        }}</span>
                        <v-icon class="warning--text ml-1"
                            >notification_important</v-icon
                        >
                    </v-btn>
                </template>
                <span>Overtime orders</span>
            </v-tooltip> -->
        </v-app-bar>

        <!-- navigation drawer -->
        <v-navigation-drawer
            v-show="show"
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            app
        >
            <v-list v-if="me">
                <v-list-item>
                    <v-list-item-avatar color="primary">
                        <v-icon dark>person</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title
                            >{{ me.firstName }}
                            {{ me.lastName }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                            me.email
                        }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
                <!-- <template v-for="(item,index) in items">
                    <v-subheader v-if="item.header" :key="item.header" inset>{{ item.header }}</v-subheader>

                    <v-divider v-else-if="item.divider" :key="index" inset></v-divider>

                    <v-list-group
                        v-else-if="item.children"
                        :key="index"
                        v-model="item.model"
                        :prepend-icon="item.model ? item.icon : item['icon-alt']"
                        append-icon
                    >
                        <template v-slot:activator>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <v-list-item v-for="(child, i) in item.children" :key="i" link>
                            <v-list-item-action v-if="child.icon">
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ child.text }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-else :key="item.text" link :href="item.url">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>-->

                <!-- home -->
                <v-list-item link href="/#/">
                    <v-list-item-action>
                        <v-icon>home</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- plants -->
                <v-list-item
                    v-if="hasPermission('view_plant')"
                    link
                    href="/#/plants"
                >
                    <v-list-item-action>
                        <v-icon>eco</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Plants</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- products -->
                <v-list-item
                    v-if="hasPermission('view_product')"
                    link
                    href="/#/products"
                >
                    <v-list-item-action>
                        <v-icon>local_offer</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Products</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- inventory -->
                <v-list-item
                    v-if="hasPermission('view_growthtaskinventorybyplant')"
                    link
                    href="/#/inventory"
                >
                    <v-list-item-action>
                        <v-icon>storefront</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Inventory</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- orders -->
                <v-list-item
                    v-if="hasPermission('view_salesorder')"
                    link
                    href="/#/orders"
                >
                    <v-list-item-action>
                        <v-icon>receipt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Orders</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- greenhouses -->
                <v-list-item
                    v-if="hasPermission('view_greenhouse')"
                    link
                    href="/#/greenhouses"
                >
                    <v-list-item-action>
                        <v-icon>view_quilt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Greenhouses</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- cost rate -->
                <v-list-item
                    v-if="hasPermission('view_plannedtask')"
                    link
                    href="/#/costrates"
                >
                    <v-list-item-action>
                        <v-icon>euro_symbol</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Cost Rates</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- planning tool -->
                <v-list-item
                    v-if="hasPermission('view_plannedtask')"
                    link
                    href="/#/planningtool"
                >
                    <v-list-item-action>
                        <v-icon>content_paste</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Planning Tool</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- p & l -->
                <v-list-item
                    v-if="hasPermission('view_plannedtask')"
                    link
                    href="/#/pl"
                >
                    <v-list-item-action>
                        <v-icon>account_balance</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>P & L</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- growthtasks -->
                <v-list-item
                    v-if="hasPermission('view_growthtask')"
                    link
                    href="/#/growthtasks"
                >
                    <v-list-item-action>
                        <v-icon>date_range</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Growth Tasks</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- customers -->
                <v-list-item
                    v-if="hasPermission('view_customer')"
                    link
                    href="/#/customers"
                >
                    <v-list-item-action>
                        <v-icon>group</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Customers</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- suppliers -->
                <v-list-item
                    v-if="hasPermission('view_supplier')"
                    link
                    href="/#/suppliers"
                >
                    <v-list-item-action>
                        <v-icon>spa</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Suppliers</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <!-- groups -->
                <v-list-item
                    v-if="hasPermission('view_tenantusergroup')"
                    link
                    href="/#/groups"
                >
                    <v-list-item-action>
                        <v-icon>people_outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Groups</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- users -->
                <v-list-item
                    v-if="hasPermission('view_customuser')"
                    link
                    href="/#/users"
                >
                    <v-list-item-action>
                        <v-icon>contacts</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Users</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <template v-slot:append>
                <div class="pa-2">
                    <v-btn
                        block
                        text
                        outlined
                        rounded
                        color="error"
                        @click="logout"
                        >Logout</v-btn
                    >
                </div>
                <center class="grey--text subtitle-2 mb-2">
                    v0.9.0 &copy; LinkThings
                </center>
            </template>
        </v-navigation-drawer>

        <!-- content -->
        <v-content fill-height>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
// import gql from "graphql-tag";
import helper from "@/utils/helper.js";
// import moment from "moment";
import Snackbar from "@/components/base/Snackbar.vue";
import QrCodeScanner from "@/components/base/QrCodeScanner.vue";

export default {
    name: "App",
    components: {
        Snackbar,
        QrCodeScanner
    },

    // apollo: {
    //     alertsCount: {
    //         query: gql`
    //             query alertsCount(
    //                 $deliverDatePlanned_Lte: DateTime
    //                 $currentGrowthTaskPhase_EndDate_Lt: Date
    //             ) {
    //                 tenantProducts(isPlantsConfigured_Iexact: false) {
    //                     totalCount
    //                 }
    //                 tenantSalesOrders(
    //                     orderStatus_Iexact: "PENDING"
    //                     deliverDatePlanned_Lte: $deliverDatePlanned_Lte
    //                 ) {
    //                     totalCount
    //                 }
    //                 tenantGrowthTasks(
    //                     totalInventory_Gt: 0
    //                     isReadyToSell: false
    //                     currentGrowthTaskPhase_EndDate_Lt: $currentGrowthTaskPhase_EndDate_Lt
    //                 ) {
    //                     totalCount
    //                 }
    //             }
    //         `,
    //         variables() {
    //             return {
    //                 deliverDatePlanned_Lte: this.today,
    //                 currentGrowthTaskPhase_EndDate_Lt: moment(
    //                     this.today
    //                 ).format("YYYY-MM-DD")
    //             };
    //         },
    //         // Additional options here
    //         fetchPolicy: "cache-and-network",
    //         update: (data) => {
    //             // localStorage.setItem("alertsCountObj", JSON.stringify(data));

    //             return data;
    //         },
    //         skip() {
    //             return !this.me;
    //         },
    //         pollInterval: 60000 // ms
    //     }
    // },

    data: () => ({
        drawer: false,
        qrCodeScannerDialog: false

        // alertsCount: {
        //     tenantProducts: { totalCount: 0 },
        //     tenantSalesOrders: { totalCount: 0 },
        //     tenantGrowthTasks: { totalCount: 0 }
        // }

        // items: [
        //     { icon: "home", text: "Home", url: "/#/" },
        //     // { header: "Plant" },
        //     // { divider: true },
        //     { icon: "eco", text: "Plants", url: "/#/plants" },
        //     // { header: "Product" },
        //     // { divider: true },
        //     { icon: "local_offer", text: "Products", url: "/#/products" },
        //     // { header: "Order & Inventory" },
        //     // { divider: true },
        //     { icon: "storefront", text: "Inventory", url: "/#/inventory" },
        //     { icon: "receipt", text: "Orders", url: "/#/orders" },
        //     // { header: "Greenhoue" },
        //     // { divider: true },
        //     { icon: "view_quilt", text: "Greenhouses", url: "/#/greenhouses" },
        //     { icon: "date_range", text: "Growth Tasks", url: "/#/growthtasks" },
        //     // { header: "Customer & Supplier" },
        //     // { divider: true },
        //     { icon: "people", text: "Customers", url: "/#/customers" },
        //     { icon: "spa", text: "Suppliers", url: "/#/suppliers" }
        //     // { icon: "group", text: "Groups", url: "/#/groups" }
        //     // { icon: "mdi-settings", text: "Settings" },
        //     // { icon: "mdi-message", text: "Send feedback" },
        //     // { icon: "mdi-help-circle", text: "Help" }
        // ]
    }),
    computed: {
        show() {
            return (
                this.$route.name !== "login"
                //  || this.$route.path === "/#/register"
            );
        },
        today() {
            var _today = new Date();
            _today.setHours(23, 59, 59, 59); // remove time

            return _today;
        },
        me() {
            return this.$store.state.user.me;
        }
    },
    created() {
        this.fetchMe();
        // copy hasPermission from helper
        this.hasPermission = helper.hasPermission;
    },
    mounted() {},
    methods: {
        fetchMe() {
            this.$store
                .dispatch("user/fetchMe")
                .then(() => {})
                .catch(error => {
                    console.log(error);
                });
        },

        logout() {
            this.$store
                .dispatch("user/logout")
                .then(() => {
                    this.drawer = false;
                    this.$router.push("/login");
                })
                .catch(error => {
                    console.log("Logout failed", error);
                });
        },

        goToUnconfiguredProducts() {
            this.$router
                .push({
                    name: "products",
                    query: { filter: "toconfig" }
                })
                .catch(() => {});
        },

        goToPendingOrders() {
            this.$router
                .push({
                    name: "orders",
                    query: { filter: "pending" }
                })
                .catch(() => {});
        }
    }
};
</script>
